import Grid2 from "@mui/material/Unstable_Grid2";
import { Link } from "react-router-dom";
import ELTRP_Logo_Horizontal_for_white_background from "../../assets/logos/ELTRP_Logo_Horizontal_for_white_background.png";
import {
  IconButton,
  Menu,
  MenuList,
} from "@mui/material";
import {
  Engineering, FeedOutlined,
  Help,
  Info,
  Mail,
  Menu as MenuIcon,
  MenuBook, MenuBookOutlined,
  MenuOpen,
  QuestionAnswer,
  Search,
  Star,
} from "@mui/icons-material";
import React, { useMemo, useState } from "react";
import { HeaderButton } from "../../components/ui/buttons/header-button";
import { UserMenu } from "../../features/users/components/user-menu";
import { MenuLink } from "./menu-item";

export const DesktopHeader = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid2 xs={12} container pl={4} pr={4}>
      <Grid2
        xlOffset={1}
        xs={3}
        xl={4}
        display="flex"
        justifyContent={"left"}
        alignItems={"center"}
      >
        <Link to="/">
          <img
            alt={"ELTRP LOGO"}
            src={ELTRP_Logo_Horizontal_for_white_background}
            style={{ width: "min(300px,30vw)" }}
          />
        </Link>
      </Grid2>
      <Grid2
        xs={7.5}
        xl={5}
        display="flex"
        justifyContent={"right"}
        alignItems={"center"}
        textAlign={"center"}
        gap={2}
      >
        <HeaderButton
          title={"Search"}
          icon={<Search />}
          to={"/search/?query=&from=0&size=10"}
        />
        <HeaderButton
          title={"Dictionary"}
          icon={<MenuBook />}
          to={"/dictionary"}
        />
        <HeaderButton
          title={"Favourites"}
          icon={<Star />}
          to={"/favourites/?from=0&size=10"}
        />
      </Grid2>
      <Grid2
        xs={1.5}
        xl={1}
        display="flex"
        justifyContent={"right"}
        alignItems={"center"}
        textAlign={"center"}
        gap={2}
      >
        <UserMenu />

        <IconButton onClick={handleClick}>
          {" "}
          {open ? <MenuOpen /> : <MenuIcon />}{" "}
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuList sx={{ minWidth: 300 }}>
            <MenuLink text={"How To Search"} to={"/how-to-search"} icon={<Help fontSize={"small"} />} />
            <MenuLink text={"Recently Added Publications"} to={"/recently-added-publications?size=10&from=0"} icon={<FeedOutlined fontSize={"small"} />} />
            <MenuLink text={"Recently Added Projects"} to={"/recently-added-projects?size=10&from=0"} icon={<Engineering fontSize={"small"} />} />
            <MenuLink text={"Dictionary"} to={"/dictionary"} icon={<MenuBookOutlined fontSize={"small"} />} />
            <MenuLink text={"Newsletter"} to={"/newsletter"} icon={<Mail fontSize={"small"} />} />
            <MenuLink text={"Contact us"} to={"/contact"} icon={<QuestionAnswer fontSize={"small"} />} />
            <MenuLink text={"About"} to={"/about"} icon={<Info fontSize={"small"} />} />
          </MenuList>
        </Menu>
      </Grid2>
    </Grid2>
  );
};
